const CUSTOM_PAY_SIM_OFFERS_PROVIDERS = {
    SIERRA_WIRELESS: {
        name: 'Sierra Wireless',
        key: 'SIERRA_WIRELESS',
        entities: {
            name: 'details.sim_offers.sierra_wireless.name',
            manage: 'details.sim_offers.sierra_wireless.manage'
        }
    },
    DEUTSCHE_TELEKOM: {
        name: 'Deutsche Telekom',
        key: 'DEUTSCHE_TELEKOM',
        entities: {
            name: 'details.sim_offers.deutsche_telekom.name',
            manage: 'details.sim_offers.deutsche_telekom.manage'
        }
    }
};

export default CUSTOM_PAY_SIM_OFFERS_PROVIDERS;